import { useFormikContext } from "formik";
import { ChangeEvent, KeyboardEvent, useEffect, useRef, useState } from "react";
import { Form, Overlay, Popover } from "react-bootstrap";
import Fuse from "fuse.js";
import { RowMouseEventHandlerParams } from "react-virtualized";
import { useDebounce } from "../../../../../../../_metronic/helpers";
import SimpleTable from "../../../../../component/table/simple-table/SimpleTable";
import { SELECTION_MODE, VARIABLE_STRING } from "../../../../../utils/Constant";
// import "../../../../../phan-he-kham-benh/PhanHeKhamBenh.scss";
// import "../../../../../component/input-autocomplete/style.scss";

const columnSelectTable = [
    {
        name: "",
        field: "radio",
        width: 50,
        textAlign: "center",
    },
    {
        name: "Mã",
        field: "code",
        width: 200,
        textAlign: "center",
    },
    {
        name: "Tên",
        field: "name",
        width: 892,
        textAlign: "left",
    },
];  

const SelectTableKCBBD = ({
    disabled,
    containerClassName,
    keyword,
    style,
    name,
}: any) => {
    const { values, setFieldValue } = useFormikContext<any>();
    const codeValue = values?.insurance?.insKcbbdCode;
    const nameValue = values?.insurance?.insKcbbdName;

    const containerRef = useRef<HTMLDivElement>(null);
    const inputRef = useRef<HTMLInputElement>(null);
    const [tableData, setTableData] = useState<any[]>([]);
    const [isShow, setIsShow] = useState<boolean>(false);
    const [selectedIndex, setSelectedIndex] = useState<number>(-1);
    const [textSearch, setTextSearch] = useState<string>("");
    const textSearchDebounce = useDebounce(textSearch?.trim(), 400);
    const [rowSelected, setRowSelected] = useState<any>(null);

    useEffect(() => {
        setRowSelected(tableData[selectedIndex]);
    }, [tableData, selectedIndex]);

    useEffect(() => {
        window.addEventListener("click", checkMouseClickOutSide, true);

        return () => {
            window.removeEventListener("click", checkMouseClickOutSide, true);
        };
    }, [codeValue, nameValue]);

    useEffect(() => {
        const fuseOptions = {
            isCaseSensitive: false, //phân biệt chữ hoa chữ thường
            includeScore: true,
            shouldSort: true,
            includeMatches: false,
            findAllMatches: false,
            minMatchCharLength: 2, //kết quả trả về cả những phần tử khớp theo số lượng ký tự truyền vào
            useExtendedSearch: true, //search nâng cao, phụ thuộc các dấu =, ", '
            ignoreLocation: true,
            ignoreFieldNorm: true,
            fieldNormWeight: 1,
            keys: [keyword],
        };
        const fuse = new Fuse([], { ...fuseOptions, keys: [keyword] });
        if (textSearchDebounce !== "") {
            const lstICD10 = fuse
                .search(textSearchDebounce ? `'${textSearchDebounce}` : "")
                .map((ser: any) => {
                    return ser?.item;
                });
            setTableData(lstICD10);
        } else {
            setTableData([]);
        }
    }, [textSearchDebounce]);


    const checkMouseClickOutSide = (e: MouseEvent) => {
        if (
            containerRef.current &&
            !containerRef.current.contains(e.target as Node)
        ) {
            setIsShow(false);
            setTextSearch(codeValue);
        }
    };

    useEffect(() => {
        textSearch !== codeValue && setTextSearch(codeValue);
    }, [codeValue, nameValue]);

    const onSearch = (e: ChangeEvent<HTMLInputElement>) => {
        if (!isShow) {
            setIsShow(true);
        };
        const inputValue = keyword === "code" ? e.target.value?.toUpperCase() : e.target.value;
        setTextSearch(inputValue);
    };

    const onRowSelect = (rowData: any) => {
        if (!rowData) return;
        setFieldValue(VARIABLE_STRING.INSURANCE, {
            ...values?.[VARIABLE_STRING.INSURANCE],
            insKcbbdCode: rowData?.code,
            insKcbbdName: rowData?.name,
        });
        setSelectedIndex(0);
        setIsShow(false);
    };

    const onContainerKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
        const dataLength = tableData.length;

        switch (e.key) {
            case "ArrowDown":
                if (!isShow) {
                    setIsShow(true);
                    return;
                }
                setSelectedIndex(
                    selectedIndex === dataLength - 1 ? 0 : selectedIndex + 1
                );
                break;
            case "ArrowUp":
                setSelectedIndex(
                    selectedIndex === 0 ? dataLength - 1 : selectedIndex - 1
                );
                break;
            case "Enter":
                e.preventDefault();
                onRowSelect({ rowData: rowSelected });
                break;
            case "Escape":
            case "Tab":
                setIsShow(false);
                break;
            case "Home":
                setSelectedIndex(0);
                break;
            case "End":
                setSelectedIndex(dataLength - 1);
                break;

            default:
                break;
        }
    };

    const handleRenderCell = (columnData: any, dataKey: string, rowData: any) => {
        if (typeof rowData.get === "function") {
            return rowData.get(dataKey);
        } else {
            return rowData[dataKey];
        }
    };

    const renderTable = () => {
        return (
            <Popover
                style={{
                    minWidth: inputRef.current?.offsetWidth,
                }}
                className="input-autocomplete-virtualize-popover"
            >
                <Popover.Body className="p-8 spaces">
                    <SimpleTable
                        data={tableData || []}
                        columns={columnSelectTable || []}
                        height={300}
                        width={1000}
                        scrollable={true}
                        type={SELECTION_MODE.SINGLE}
                        dataChecked={[rowSelected]}
                        handleRenderCell={handleRenderCell}
                        onRowClick={(rowData: RowMouseEventHandlerParams) => {
                            onRowSelect(rowData);
                        }}
                    />
                </Popover.Body>
            </Popover>
        );
    };

    return (
        <>
            <div className="d-flex align-items-center w-100"
                style={style}
                ref={containerRef}
                onKeyDown={onContainerKeyDown}
            >
                <Form.Group className="w-100 position-relative">
                    <Form.Control
                        className="spaces px-4 customs-input"
                        ref={inputRef}
                        name={name}
                        value={textSearch || ""}
                        onChange={onSearch}
                        onFocus={() => {
                            setIsShow(true);
                        }}
                        disabled={disabled}
                    />
                </Form.Group>
            </div>

            <Overlay
                placement="bottom-start"
                target={inputRef.current}
                container={containerRef.current}
                offset={[0, 3]}
                show={isShow}
            >
                {renderTable()}
            </Overlay>
        </>
    );
};

type Props = {
    disabled?: boolean;
    containerClassName?: string;
    widthInputCode?: number
}

const KCBBD = ({
    disabled,
    containerClassName,
    widthInputCode = 100,
}: Props) => {

    return (
        <div
            className={`d-flex spaces w-100 position-relative ${containerClassName || ""}`}
        >
            <SelectTableKCBBD 
                name="insKcbbdCode"
                keyword="code"
                style={{ flex: `0 1 ${widthInputCode}px` }}
                disabled={disabled}
            />
            <SelectTableKCBBD
                name="insKcbbdName"
                keyword="name"
                style={{ flex: '1' }}
                disabled={disabled}
            />
        </div>
    );
};

export default KCBBD;
